var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Line Chart, 折线图。")]),
      _vm._v(" "),
      _c("h3", [_vm._v("属性 attrs")]),
      _vm._v(" "),
      _c("p", [_vm._v("通过设置 Line 的属性来产生不同的样式，包含若干属性")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性名")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("clientRect")]),
            _vm._v(" "),
            _c("td", [_vm._v("Object")]),
            _vm._v(" "),
            _c("td", [_vm._v("{top,right,bottom,left,width,height}")]),
            _vm._v(" "),
            _c("td", [_vm._v("设置了 width,heigh,优先与 bottom,right")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("smooth")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")]),
            _vm._v(" "),
            _c("td", [_vm._v("曲线是否平滑")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("axisGap")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")]),
            _vm._v(" "),
            _c("td", [_vm._v("开始绘图区域与坐标轴是否有间隙")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("splitNumber")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("0")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "坐标轴的分割段数，用来计算线的最大高度，在设置坐标轴的 splitNumber 属性时同步加上"
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("style 属性")]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" line = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Line({ "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("smooth")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-literal" } }, [
              _vm._v("true")
            ]),
            _vm._v(" })\nline.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'point'")
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("pointType")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v("'star'")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("size")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("8")
            ]),
            _vm._v(" })\n")
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义 css 属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基础类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("guideline")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("指导线样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("line")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("线条样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("point")]),
            _vm._v(" "),
            _c("td", [
              _vm._v("面，除了基础面的全部属性外，还有("),
              _c(
                "a",
                {
                  staticStyle: { "text-decoration": "underline" },
                  attrs: { href: "./#/doc/plugin/Point" }
                },
                [_vm._v("Point")]
              ),
              _vm._v(")的特殊属性")
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("线条上标记点样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("point:hover")]),
            _vm._v(" "),
            _c("td", [
              _vm._v("面，除了基础面的全部属性外，还有("),
              _c(
                "a",
                {
                  staticStyle: { "text-decoration": "underline" },
                  attrs: { href: "./#/doc/plugin/Point" }
                },
                [_vm._v("Point")]
              ),
              _vm._v(")的特殊属性")
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("hover 时线条上标记点样式")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }